export default __webpack_public_path__ + "static/media/cancer_type_Hk.1f64b47e.webp";